import React from "react";
import { Flex, type FlexProps } from "@chakra-ui/react";

export function Checkbox({ children, ...props }: FlexProps) {
  return (
    <Flex
      align="center"
      border="1px"
      borderColor="new.gray.300"
      borderRadius="5px"
      boxSize="16px"
      bg="white"
      flexShrink={0}
      justify="center"
      transition="100ms cubic-bezier(0.4, 0, 1, 1)"
      transitionProperty="border-color, background-color"
      {...props}
    >
      {children}
    </Flex>
  );
}
